import { render, staticRenderFns } from "./SpeakerSessions.vue?vue&type=template&id=a04062fe&"
import script from "./SpeakerSessions.vue?vue&type=script&lang=js&"
export * from "./SpeakerSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports